import { type TagWithScope } from '#shared/lib/integrations';
import { getTagKeysByScope } from './getTagKeysByScope';

export const mapIntegrationSelectedTagsToMappingPayload = (selectedTags: TagWithScope[]) => {
    return {
        characteristic_ids: getTagKeysByScope(selectedTags, 'characteristic'),
        custom_slugs: getTagKeysByScope(selectedTags, 'property'),
    };
};
